import fetch from './index'

// Shopify 商品下沉（add-shopify-product-downsink）gateway API 封装
// 当前用户可见站点(按归属渠道过滤;openspec add-shopify-site-channel-scope)
export function getShopifyVisibleSites(): any {
  return fetch.get(`/edata/shopify/product/sites/visible`)
}
export { getShopifySiteSignConfigAll } from './store'

// 查询 Shopify 订单回流数据
export function queryShopifyOrderData(params): any {
  return fetch.post('/edata/item/shopify/order', params)
}

// ============ 商品查询 ============

// 分页查询商品记录表(ERP 镜像)
export function queryShopifyProductPage(params): any {
  return fetch.post('/edata/shopify/product/query/page', params)
}
// 按条件查询 ERP 镜像商品(不打 shopify)
export function queryShopifyProductFromDb(siteId, params): any {
  return fetch.post(`/edata/shopify/product/db/query/${siteId}`, params)
}
// 按 id 实时拉取 shopify 商品详情(远端全量,含分页取全的关联数据)
export function queryShopifyProductById(siteId, productId): any {
  return fetch.post(`/edata/shopify/product/query/${siteId}`, null, { params: { productId } })
}

// ============ 商品写操作(异步 outbox) ============

// 全量更新商品,返回 outbox 任务 id
export function updateShopifyProduct(siteId, params): any {
  return fetch.post(`/edata/shopify/product/update/${siteId}`, params)
}
// 差量更新商品(只提交改动字段),返回 outbox 任务 id
export function patchUpdateShopifyProduct(siteId, params): any {
  return fetch.post(`/edata/shopify/product/patch/update/${siteId}`, params)
}
// 上架(创建)商品
export function saleShopifyProduct(siteId, params, publicationId?: string): any {
  return fetch.post(`/edata/shopify/product/sale/${siteId}`, params, { params: { publicationId } })
}
// 向导显式多渠道路径；旧 saleShopifyProduct 的标量响应不变。
export function createShopifyProductWithPublications(siteId, params, publicationIds: string[]): any {
  return fetch.post(`/edata/shopify/product/sale/${siteId}`, params, { params: { publicationIds: publicationIds.join(',') } })
}
export function queryShopifyLivePublications(siteId): any {
  return fetch.get(`/edata/shopify/product/publications/live/${siteId}`)
}
// 删除商品
export function deleteShopifyProduct(siteId, productId): any {
  return fetch.post(`/edata/shopify/product/delete/${siteId}`, null, { params: { productId } })
}

// ============ 媒体 / 选项 / 元字段 ============

// 新增商品图片(media)
export function createShopifyProductMedia(siteId, params): any {
  return fetch.post(`/edata/shopify/product/create/media/${siteId}`, params)
}
// 删除商品图片(media)
export function deleteShopifyProductMedia(siteId, params): any {
  return fetch.post(`/edata/shopify/product/delete/media/${siteId}`, params)
}
// 新增商品选项
export function createShopifyProductOptions(siteId, params): any {
  return fetch.post(`/edata/shopify/product/create/options/${siteId}`, params)
}
// 修改商品选项
export function updateShopifyProductOptions(siteId, params): any {
  return fetch.post(`/edata/shopify/product/update/options/${siteId}`, params)
}
// 更新商品 metafields
export function updateShopifyProductMetafields(siteId, params): any {
  return fetch.post(`/edata/shopify/product/update/metafields/${siteId}`, params)
}
// 删除商品 metafields
export function deleteShopifyProductMetafields(siteId, params): any {
  return fetch.post(`/edata/shopify/product/delete/metafields/${siteId}`, params)
}

// 强制同步商品最新信息(后门,按 productIds 拉 shopify 覆盖镜像)
export function syncShopifyProducts(siteId, productIds): any {
  return fetch.post(`/edata/shopify/product/asyn/${siteId}`, productIds)
}

// ============ 治理 / 变更记录 ============

// 商品保护标记(isProtected)
export function protectShopifyProduct(siteId, params): any {
  return fetch.post(`/edata/shopify/product/protect/${siteId}`, params)
}
// 变更记录回滚
export function revertShopifyProductChangeLog(params): any {
  return fetch.post('/edata/shopify/product/changelog/revert', params)
}

// ============ 推送记录(outbox) ============

// 分页查询推送任务
export function queryShopifyOutboxPage(params): any {
  return fetch.post('/edata/shopify/product/outbox/query/page', params)
}
// 手动重试 PERMANENT_FAILED 任务
export function retryShopifyOutbox(id): any {
  return fetch.post(`/edata/shopify/product/outbox/retry/${id}`, {})
}

// ============ 商品变体 ============

// 查询商品变体镜像列表
export function queryShopifyVariantList(params): any {
  return fetch.post('/edata/shopify/product/variant/query/list', params)
}
// 更新商品变体价格等字段
export function updateShopifyVariant(siteId, params): any {
  return fetch.post('/edata/shopify/product/variant/update/' + siteId, params)
}
// 设置商品变体库存数量
export function setShopifyVariantInventoryQuantity(siteId, params): any {
  return fetch.post('/edata/shopify/product/variant/update/inventory/quantity/' + siteId, params)
}

// 商品媒体重排序（shopify 异步 job）
export function reorderShopifyProductMedia(siteId, params): any {
  return fetch.post('/edata/shopify/product/reorder/media/' + siteId, params)
}

// 分页查询商品合集镜像
export function queryShopifyCollectionPage(params): any {
  return fetch.post('/edata/shopify/product/collection/page', params)
}

// 分页查询 Shopify 销售渠道镜像
export function queryShopifySaleChannelPage(params): any {
  return fetch.post('/edata/shopify/sale/channel/page', params)
}

// 查询 Shopify metafield 定义列表
export function queryShopifyMetafieldDefinitions(params): any {
  return fetch.post('/edata/shopify/metafield/definition/query/list', params)
}

// 按关联定义查询 Shopify metaobject 镜像列表
export function queryShopifyMetaObjects(params): any {
  return fetch.post('/edata/shopify/meta/objects/query/list', params)
}

// 创建商品后批量创建变体，并按 strategy 处理 productCreate 自动生成的默认变体
export function saleOnShopifyVariants(siteId, params): any {
  return fetch.post('/edata/shopify/product/variant/sale/on/' + siteId, params)
}


// 分页查询 Shopify 商品变更记录
export function queryShopifyChangeLogPage(params): any {
  return fetch.post('/edata/shopify/product/changelog/query/page', params)
}


// 合集挂载商品（shopify 异步 job）
export function addProductsToShopifyCollection(siteId, params): any {
  return fetch.post(`/edata/shopify/product/collection/products/add/${siteId}`, params)
}

// 合集移除商品（shopify 异步 job）
export function removeProductsFromShopifyCollection(siteId, params): any {
  return fetch.post(`/edata/shopify/product/collection/products/remove/${siteId}`, params)
}

// 创建 Shopify 合集并返回新合集 gid
export function createShopifyCollection(siteId, params): any {
  return fetch.post(`/edata/shopify/product/collection/create/${siteId}`, params)
}

// 从 Shopify 拉取全量合集镜像
export function synShopifyCollections(siteId): any {
  return fetch.post(`/edata/shopify/product/collection/syn/all/${siteId}`, {})
}

// 发布商品到 Shopify 销售渠道（shopify 异步 job）
export function publishShopifyProduct(siteId, params): any {
  return fetch.post(`/edata/shopify/product/publication/publish/${siteId}`, params)
}

// 从 Shopify 销售渠道撤出商品（shopify 异步 job）
export function unpublishShopifyProduct(siteId, params): any {
  return fetch.post(`/edata/shopify/product/publication/unpublish/${siteId}`, params)
}

// ============ options 字典（canonical+alias 两层,全局一套+站点覆盖） ============

// 创建向导词表:该站已有 product_type / tags / 默认 vendor(镜像聚合)
export function queryShopifyProductVocab(siteId): any {
  return fetch.get(`/edata/shopify/product/option/dict/vocab/${siteId}`)
}

// 该站已用商品模板后缀(templateSuffix)去重,供创建/编辑向导下拉建议
export function queryShopifyTemplateSuffixes(siteId): any {
  return fetch.get(`/edata/shopify/product/template/suffixes/${siteId}`)
}

// 字典查询:siteId 非空=全局∪站点合并(下拉用);siteId 空=全部作用域(维护页用)
export function queryShopifyOptionDict(params): any {
  return fetch.post('/edata/shopify/product/option/dict/query', params)
}

// 字典名称条目创建/更新(含取值全量 upsert;只停用不删除)
export function saveShopifyOptionDict(params): any {
  return fetch.post('/edata/shopify/product/option/dict/save', params)
}

// ============ options 模板(≤3 维快照,全局一套+站点覆盖,跟站点走) ============

// 模板查询:siteId 非空=全局∪站点合并(创建页载入下拉);siteId 空=全部作用域(维护页)
export function queryShopifyOptionTemplate(params): any {
  return fetch.post('/edata/shopify/product/option/template/query', params)
}

// 模板创建/更新(同作用域同名创建冲突;前端提示覆盖时带 id 走更新;只停用不删除)
export function saveShopifyOptionTemplate(params): any {
  return fetch.post('/edata/shopify/product/option/template/save', params)
}

// ============ 商品事件 + 时间线 ============

// 事件类型列表(includeDisabled=true 维护页看全量)
export function queryShopifyEventTypes(includeDisabled?: boolean): any {
  return fetch.get('/edata/shopify/product/event/type/list', { params: { includeDisabled } })
}

// 事件类型创建/更新(系统类型只读;只停用不删除)
export function saveShopifyEventType(params): any {
  return fetch.post('/edata/shopify/product/event/type/save', params)
}

// 事件登记(operatorId 网关入口注入)
export function addShopifyProductEvent(params): any {
  return fetch.post('/edata/shopify/product/event/add', params)
}

// 商品时间线(changelog+event 合并流,操作人姓名已回填)
export function queryShopifyProductTimeline(params): any {
  return fetch.post('/edata/shopify/product/event/timeline', params)
}

// 时间线流量曲线(listing_url → idp 日 rollup;未接埋点站点返回空)
export function queryShopifyProductPageTrend(url: string, days?: number): any {
  return fetch.get('/edata/shopify/product/timeline/pagetrend', { params: { url, days } })
}
